import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export type AiPostActionDialogVariant = 'accounts' | 'images' | 'schedule' | 'posts' | 'generic';

export interface AiPostActionDialogData {
  title: string;
  message: string;
  steps?: string[];
  variant?: AiPostActionDialogVariant;
  confirmLabel?: string;
}

@Component({
  selector: 'app-ai-post-action-dialog',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './ai-post-action-dialog.component.html',
  styleUrl: './ai-post-action-dialog.component.scss',
})
export class AiPostActionDialogComponent implements OnInit {
  title = 'Almost there';
  message = '';
  steps: string[] = [];
  variant: AiPostActionDialogVariant = 'generic';
  confirmLabel = 'Got it';

  constructor(
    private readonly config: DynamicDialogConfig<AiPostActionDialogData>,
    private readonly ref: DynamicDialogRef
  ) {}

  ngOnInit() {
    const data = this.config.data;
    this.title = data?.title || this.title;
    this.message = data?.message || '';
    this.steps = data?.steps || [];
    this.variant = data?.variant || 'generic';
    this.confirmLabel = data?.confirmLabel || 'Got it';
  }

  close() {
    this.ref.close();
  }

  get iconGlyph(): string {
    switch (this.variant) {
      case 'accounts':
        return '👤';
      case 'images':
        return '🖼';
      case 'schedule':
        return '📅';
      case 'posts':
        return '☑';
      default:
        return '✦';
    }
  }
}
